<template>
  <div class="graph-container">
    <svg ref="svg" class="chart"></svg>
  </div>
</template>

<script>
import * as d3 from "d3";

export default {
  setup() {},
  mounted() {
    this.margin = { top: 50, right: 50, bottom: 50, left: 100 },
    this.width = 1152 - this.margin.left - this.margin.right,
    this.height = 600 - this.margin.top - this.margin.bottom;
    this.svg = d3
      .select(this.$refs.svg)
      .attr("width", this.width + this.margin.left + this.margin.right)
      .attr("height", this.height + this.margin.top + this.margin.bottom)
      .append("g")
      .attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");

    this.xAxis = this.svg.append("g").attr("transform", "translate(0," + this.height + ")");

    this.yAxis = this.svg.append("g");
    this.updateHistogram(this.data);

    var yAxisLabel = this.svg.append("text").attr("class", "y label").attr("text-anchor", "middle").attr("y", -50).attr("x", -250).attr("dy", ".75em").attr("transform", "rotate(-90)").text("Occurences").attr("style", "fill: gray; font-size: 1.3em;");
    var xAxisLabel = this.svg.append("text").attr("class", "x label").attr("text-anchor", "middle").attr("y", 523).attr("x", 500).attr("dy", ".75em").text("Days").attr("style", "fill: gray; font-size: 1.3em;");
  },
  data() {
    return {
      data: null,
    };
  },
  methods: {
    updateData(data) {
      this.data = data;

      this.updateHistogram(data);
    },
    updateHistogram(data) {

    this.svg
        .selectAll("rect").remove()
      if (data == null) {
        return;
      }

      // append the this.svg object to the body of the page// append the this.svg object to the body of the page

      var xDomain = [Math.floor(2  * d3.min(data, function(d){return d.days}) - 1) / 2, Math.ceil(2 * d3.max(data, function(d){return d.days})+ 1) / 2]

      if (data.length == 0) {
        xDomain = [0, 1];
      }

      var x = d3
        .scaleLinear()
        .domain(xDomain) // can use this instead of 1000 to have the max of data: d3.max(data, function(d) { return +d.price })
        .range([0, this.width]);

      this.xAxis.call(d3.axisBottom(x));

      var histogram = d3
        .histogram()
        .value(function (d) {
          return d.days;
        }) // I need to give the vector of value
        .domain(x.domain()) // then the domain of the graphic
        .thresholds(x.ticks(Math.round(xDomain[1] - xDomain[0]) / 1)); // then the numbers of bins

      var bins = histogram(data);
      // Y axis: scale and draw:
      var y = d3.scaleLinear().range([this.height, 0]);
      y.domain([
        0,
        d3.max(bins, function (d) {
          return d.length;
        }),
      ]); // d3.hist has to be called before the Y axis obviously

      if(data.length == 0){
        y.domain([0, 1])
      }
      this.yAxis.call(d3.axisLeft(y));
      // append the bar rectangles to the this.svg element
    var self = this;
      this.svg
        .selectAll("rect")
        .data(bins)
        .enter()
        .append("rect")
        .attr("x", 1)
        .attr("transform", function (d) {
          return "translate(" + x(d.x0) + "," + y(d.length) + ")";
        })
        .attr("width", function (d) {
          return d3.max([x(d.x1) - x(d.x0) - 1, 0]);
        })
        .attr("height", function (d) {
          return self.height - y(d.length);
        })
        .style("fill", "#9ab5db");
    },
  },
};
</script>
